import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

//styles 

import './assets/css/plugins/bootstrap.min.css';
import './assets/css/plugins/font-awesome.css';
import './assets/css/plugins/magnific-popup.css';
import './assets/css/plugins/simplebar.css';
import './assets/css/plugins/owl.carousel.min.css';
import './assets/css/plugins/owl.theme.default.min.css';
import './assets/css/plugins/jquery.animatedheadline.css';

//CSS Base
import './assets/css/style-dark.css';
import './assets/css/style-demo.css';

//Settings Style
 
import './assets/css/settings/left-nav.css';
import './assets/css/settings/green-color.css';
import './assets/css/settings/circle-box.css';

import './index.css';

ReactDOM.render(   <BrowserRouter><App /></BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
